import { FuseAnimate } from "@fuse";
import _ from "@lodash";
import { Table, TableBody, TableCell, TableHead, TableRow, TextField, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import DashboardFuncionalidade from "app/Core/Components/DashboardFuncionalidade/DashboardFuncionalidade";
import PesquisaPainel from "app/Core/Components/PesquisaPainel/PesquisaPainel";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as Helpers from "app/Core/Helpers";
import NovoFluxoApp from "app/Workflow/MinhasTarefas/Apps/NovoFluxoApp";
import classNames from "classnames";
import MobileDetect from "mobile-detect";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import ImprimirApp from "../../Core/Components/Imprimir/ImprimirApp";
import * as Actions from "./Store/Actions/EmpresaFinanceiroActions";

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    footer: {
        display: "flex",
        position: "fixed",
        right: 30,
        bottom: 50,
        zIndex: 99
    },
    anotherLine: {
        backgroundColor: theme.palette.type === "dark" ? "#303030" : "#D4D4D4"
    }
});

const parametros = {
    filter: {
        AND: [
            { "Campo": "tarefaprocessoapontamentoitem.baixa", "Operador": ">=", "Valor": (Helpers.GetDataAtual(null, "usa") + " 00:00:00") },
            { "Campo": "tarefaprocessoapontamentoitem.baixa", "Operador": "<=", "Valor": (Helpers.GetDataAtual(null, "usa") + " 23:59:59") },
            { "Campo": "tarefaprocessoapontamentoitem.idpessoaformularioconta", "Operador": "=", "Valor": null }
        ]
    }
};

class EmpresaFinanceiroExtrato extends XAPPComponent {

    state = {
        inicio: Helpers.GetDataFirstDayMonth("usa"),
        termino: Helpers.GetDataAtual(null, "usa"),
        forceRefresh: 0
    };

    componentDidMount() {
        const xappRouteParams = this.props.match.params;
        this.listFilter();
    }

    componentDidUpdate(prevProps, prevState) {
        if (_.isNull(this.props.getAcoes()) || !_.isEqual(prevProps.data, this.props.data)) {
            this.props.setAcoes(
                <NovoFluxoApp
                    type="Fab"
                    className={classNames("text-white mt-12")}
                    variant="contained"
                    color="primary"
                    tipo={111}
                    get={"SEL"}
                    idpessoa={this.props.xappRouteParams.empresa}
                    iconProps={"justify-center"}
                    icon={"add"}
                    tooltip={{ "title": "Novo lançamento", "placement": "top" }}
                    showDialog={true}
                    callback={this.listFilter}
                    data={{ idpessoaformularioconta: this.props.idpessoaformularioconta }}
                    xappRouteParams={this.props.xappRouteParams}
                />
            );
        }

        if (!_.isNull(this.props.dataBase) && !_.isEqual(this.props.dataBase, prevProps.dataBase)) {
            this.setState({
                ...this.state,
                "inicio": Helpers.GetDataFirstDayMonth("usa", this.props.dataBase),
                "termino": Helpers.GetDataLastDayMonth("usa", this.props.dataBase),
                "forceRefresh": 1
            });
        }

        if (this.state.forceRefresh === 1 && !_.isEqual(this.state.forceRefresh, prevState.forceRefresh)) {
            this.listFilter();
            this.setState({
                ...this.state,
                "forceRefresh": 0
            });
        }
    }

    componentWillUnmount() {
        this.props.setAcoes(null);
    }

    getColumns = () => {
        var AResponse = [];
        const Columns = [
            {
                Header: "Natureza",
                accessor: "naturezadescricao",
                align: "center"
            },
            {
                Header: "Categoria",
                accessor: "idpessoaformulariocategoriadescricao",
                align: "center"
            },
            {
                Header: "Origem",
                accessor: "origem",
                align: "center"
            },
            {
                Header: "Data",
                accessor: "baixadescricao",
                align: "center"
            },
            {
                Header: "Valor",
                accessor: "valordescricao",
                align: "center"
            },
            {
                Header: "Saldo",
                accessor: "saldodescricao",
                align: "center"
            }
        ];
        return Columns;
    };

    getExtrato = () => {
        var AResponse = [];
        const { data } = this.props;
        if (!_.isUndefined(data) && !_.isNull(data)) {
            return data;
        }
        return AResponse;
    };

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.value));
    };

    listFilter = () => {
        const xappRouteParams = this.props.match.params;
        const form = this.state;
        var AFilter = JSON.parse(JSON.stringify(parametros.filter));
        if (form.inicio !== AFilter.AND[0].Valor && form.termino !== AFilter.AND[1].Valor) {
            AFilter.AND[0].Valor = form.inicio + " 00:00:00";
            AFilter.AND[1].Valor = form.termino + " 23:59:59";
        }
        AFilter.AND[2].Valor = this.props.idpessoaformularioconta;
        this.props.listExtrato(xappRouteParams, AFilter);
    };

    canBeFilter = () => {
        const { inicio, termino } = this.state;
        return (
            inicio !== null && inicio !== "" &&
            termino !== null && termino !== ""
        );
    };

    render() {
        const { classes, theme } = this.props;
        const form = this.state;
        var bgColor = 0;

        return (
            <React.Fragment>
                <PesquisaPainel
                    id="extrato"
                    anchor="left"
                    onRef={instance => this.PesquisaPainel = instance}
                >
                    <div className={"flex flex-col p-12 text-center items-center"}>
                        <TextField
                            className="mb-12"
                            id="inicio"
                            name="inicio"
                            label="Início"
                            value={form.inicio}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            type="date"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <TextField
                            className="mb-12"
                            id="termino"
                            name="termino"
                            label="Término"
                            value={form.termino}
                            onChange={this.handleChange}
                            variant="outlined"
                            type="date"
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </div>
                    <div className="flex p-12 gap-6">
                        <div className="flex-1" />
                        <XAPPButton
                            className="text-white"
                            label="Pesquisar"
                            type="Button"
                            variant="contained"
                            color="primary"
                            icon="search"
                            iconProps="text-20 mr-8"
                            disabled={!this.canBeFilter()}
                            onClick={() => {
                                this.listFilter();
                                if (!_.isUndefined(this.PesquisaPainel)) {
                                    this.PesquisaPainel.togglePainel("extrato", 0, this.clearFiltro);
                                }
                            }}
                        />
                    </div>
                </PesquisaPainel>
                <DashboardFuncionalidade
                    funcionalidade={"extrato"}
                    data={this.getExtrato()}
                    agrupador={"naturezadescricao"}
                    conteudo={"valor"}
                >
                    {this.getExtrato().length > 0 &&
                        <ImprimirApp
                            data={this.props.data}
                            key="btnImprimir"
                            id="EmpresaFinanceiroExtrato"
                            label="EXTRATO"
                            column={this.getColumns()}
                            className="p-6"
                            type="icon"
                            color="action"
                        />
                    }
                </DashboardFuncionalidade>
                <FuseAnimate animation="transition.slideUpIn" delay={300}>
                    <Table className="min-w-full" aria-labelledby="tableTitle">
                        <TableHead>
                            <TableRow className="h-48">
                                {this.getColumns().map(column => (
                                    <TableCell
                                        key={column.accessor}
                                        align={"center"}
                                        style={{ padding: "2px 12px 2px 12px" }}
                                    >
                                        {column.Header}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.getExtrato().map(n => {
                                bgColor = bgColor === 0 ? 1 : 0;
                                return (
                                    <React.Fragment>
                                        <TableRow className={classNames("", bgColor === 1 && classes.anotherLine)}>
                                            {this.getColumns().map(column => {
                                                return (
                                                    <TableCell component="th" scope="row" align={column.align} style={{ padding: "2px 12px 2px 12px" }}>
                                                        {n[column.accessor]}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                        {(!_.isNull(n.observacao) && n.observacao !== "") &&
                                            <TableRow className={classNames("h-24", theme.palette.type === "dark" ? "bg-grey-darkest" : "bg-grey-light")}>

                                                <TableCell component="th" scope="row"></TableCell>
                                                <TableCell colspan={this.getColumns().length - 1} component="th" scope="row" align={"start"} style={{ padding: "2px 12px 2px 12px" }}>
                                                    {(!_.isNull(n.observacao) ? (n.observacao) : "")}
                                                </TableCell>
                                            </TableRow>
                                        }
                                    </React.Fragment>
                                );
                            })}
                        </TableBody>
                    </Table>
                </FuseAnimate>
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        listExtrato: Actions.listExtrato,
        save: Actions.save,
    }, dispatch);
}

function mapStateToProps({ EmpresaFinanceiro, fuse }) {
    return {
        EmpresaFinanceiro: EmpresaFinanceiro,
        theme: fuse.settings.mainTheme,
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaFinanceiroExtrato)));
